// extracted by mini-css-extract-plugin
export var author = "lpBlockquoteSection-module--author--c7962";
export var blockquote = "lpBlockquoteSection-module--blockquote--19ca3";
export var citation = "lpBlockquoteSection-module--citation--dfe84";
export var company = "lpBlockquoteSection-module--company--814c2";
export var container = "lpBlockquoteSection-module--container--aec23";
export var photo = "lpBlockquoteSection-module--photo--c8264";
export var quote = "lpBlockquoteSection-module--quote--edfb0";
export var quoteSymbol = "lpBlockquoteSection-module--quote-symbol--98c91";
export var wrapper = "lpBlockquoteSection-module--wrapper--4f608";